import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const CategorySelect = ({
  value,
  options,
  onChange
}) => {
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "token-type-select",
    onChange: onChange,
    options: options,
    placeholder: "Select a type",
    value: value
  });
};
CategorySelect.displayName = 'CategorySelect';
export default CategorySelect;